import { PlatformUserAvatar } from 'src/components';
import { PlatformUserAvatarProps } from 'src/components/PlatformUserAvatar/platform-user-avatar';

/** The small avatar of a reply's author or of the person replying. */
export const ReplyAvatar = (props: Omit<PlatformUserAvatarProps, 'sx'>) => (
  <PlatformUserAvatar
    {...props}
    sx={(theme) => ({
      width: theme.spacing(3),
      height: theme.spacing(3),
      fontSize: theme.typography.caption.fontSize,
    })}
  />
);
